"use strict";
/* eslint-disable functional/prefer-readonly-type */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCrimesByLocationRequest = exports.searchLocationRequest = void 0;
// TODO move these to the ukPoliceData folder
/**
 * This file is to hold all type Police Data API calls.
 */
const fluture_1 = require("fluture");
const monet_1 = require("monet");
const thirdpartytools_1 = require("../secrets/thirdpartytools");
const fluture_utils_1 = require("../utils/fluture-utils");
/**
 * @package
 */
const searchLocationRequest = (location) => (0, fluture_1.attemptP)(() => fetch(`${thirdpartytools_1.mapBoxUrl}/mapbox.places/${location}.json?access_token=${thirdpartytools_1.mapBoxToken}`))
    .pipe((0, fluture_1.chain)((res) => (0, fluture_utils_1.attemptBody)(res)))
    .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull));
exports.searchLocationRequest = searchLocationRequest;
/**
 * @package
 */
const getCrimesByLocationRequest = (coordinates, date) => {
    const [lng, lat] = coordinates;
    return (0, fluture_1.attemptP)(() => fetch(`${thirdpartytools_1.policeDataUrl}/crimes-street/all-crime?lat=${lat}&lng=${lng}&date=${date}`))
        .pipe((0, fluture_1.chain)((res) => (0, fluture_utils_1.attemptBody)(res)))
        .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull));
};
exports.getCrimesByLocationRequest = getCrimesByLocationRequest;
//# sourceMappingURL=api.js.map